import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import Config from '@skin_config';
import { t } from '@common/helpers/translator';
import { POPUPS } from '@common/constants/popups';
import { PopupContext } from '@app/dev/contexts/popup';

import './style.scss';
import { useSelector } from 'react-redux';

const LockTerminal = (props) => {
  const { data = -1 } = props;
  const [{ openPopup }] = useContext(PopupContext);
  const customError = t(`terminal_error_${data}`);
  const isCustomErrorExists = customError !== `terminal_error_${data}`;
  const isAdminLoggedIn = useSelector((state) => state.terminal.isAdminLoggedIn);

  const openLoginForm = () => openPopup(POPUPS.LOGIN_FORM, {
    disableClose: true,
    signInToAdmin: true,
    popupPosition: 'top',
  });

  const onPopupClick = () => {
    if (Config.terminal.openLoginFormFromLockTerminal) {
      openLoginForm();
    }
  };

  return (
    <div className="popup-content popup-small lockterminal" onClick={onPopupClick}>
      <div className="popup-message error" />
      <h3 className="popup-title">
        {isCustomErrorExists && Config.main.showCustomLockScreenMessages ? customError : t('Sorry, the terminal is currently unavailable ({1})', data)}
      </h3>
      <div className="popup-actions">
        {!Config.terminal.openLoginFormFromLockTerminal && isAdminLoggedIn
          && (
            <button
              type="button"
              className="popup-confirm-button"
              onClick={openLoginForm}
            >
              {t('Login')}
            </button>
          )}
      </div>
    </div>
  );
};

LockTerminal.propTypes = {
  data: PropTypes.string,
};

export default LockTerminal;
